<template>
  <section
    id="hero"
    class="hero"
  >
    <div class="content container">
      <div>
        <div class="hero-heading">
          <div class="heading">
            <p class="badge">The global network for serious tech talent</p>
            <h1>
              A career without borders,
              <br />
              built on professional excellence
            </h1>
            <p class="subtitle">
              Proxify connects top-tier software, data, and AI professionals
              with long-term remote roles at serious companies. We handle the
              heavy lifting of connecting you to the right opportunities while
              you focus on the work, wherever you call home.
            </p>
          </div>
          <NuxtPicture
            :src="`/images/home-page/hero/hero-image.webp`"
            alt="Developer working remotely"
            class="image"
          />
        </div>

        <div class="check">
          <GradientCheckIcon />
          <p>300+ new jobs every month in engineering, data, AI, and more</p>
        </div>

        <div class="buttons">
          <ApplyButton
            page-name="homepage"
            cta-section="hero"
            class="proxify-btn"
          />
          <Glassdoor
            score="4.2"
            color="#48A069"
          />
        </div>
      </div>

      <NuxtPicture
        :src="`/images/home-page/hero/hero-image.webp`"
        alt="Developer working remotely"
        class="image"
      />
    </div>
  </section>
</template>

<script>
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';
import Glassdoor from '~/components/Common/Glassdoor/Glassdoor.vue';
import GradientCheckIcon from '~/components/Common/Svg/Gradient/GradientCheckIcon.vue';

export default {
  components: {
    GradientCheckIcon,
    ApplyButton,
    Glassdoor,
  },
};
</script>

<style lang="scss" scoped>
@import './HeroSection.scss';
</style>
